import * as React from "react"

function GatsbyOssIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 15.5405C19.7969 15.5405 15.5405 19.7969 15.5405 25C15.5405 30.203 19.7969 34.4594 25 34.4594C30.203 34.4594 34.4595 30.203 34.4595 25C34.4595 19.7969 30.203 15.5405 25 15.5405Z"
        fill="#663399"
      />
      <path
        d="M19.7294 30.2696C18.3101 28.8503 17.5674 26.9584 17.5674 25.134L24.9324 32.4315C23.0405 32.364 21.1487 31.6888 19.7294 30.2696Z"
        fill="white"
      />
      <path
        d="M26.6219 32.2287L17.7701 23.3769C18.5127 20.0657 21.4863 17.5662 25 17.5662C27.4996 17.5662 29.6615 18.7829 31.0133 20.6073L29.9991 21.485C28.8499 19.9307 27.0255 18.9179 24.9986 18.9179C22.364 18.9179 20.1332 20.6073 19.2554 22.9718L27.0255 30.7419C28.985 30.0667 30.4717 28.3774 30.9444 26.3505H27.7007V24.9987H32.4312C32.4326 28.5124 29.933 31.486 26.6219 32.2287Z"
        fill="white"
      />
      <circle
        cx="25"
        cy="25.0001"
        r="14.1149"
        stroke="#F1DEFA"
        strokeWidth="1.5"
      />
      <circle cx="25" cy="25" r="18.1689" stroke="#F6EDFA" strokeWidth="1.5" />
      <circle cx="25" cy="25" r="20.8716" stroke="#FCFAFF" strokeWidth="1.5" />
      <circle cx="43.5811" cy="27.027" r="0.675676" fill="#F67300" />
      <circle cx="8.44594" cy="16.2162" r="0.675676" fill="#FFB238" />
      <circle cx="14.8649" cy="14.527" r="0.675676" fill="#00BDB6" />
      <circle cx="20.2703" cy="43.2433" r="0.675676" fill="#00BDB6" />
      <circle cx="36.8243" cy="16.2162" r="0.675676" fill="#FA2915" />
      <circle cx="33.1081" cy="8.10806" r="1.35135" fill="#FEC21E" />
      <circle cx="33.1081" cy="37.1622" r="0.675676" fill="#59C156" />
      <circle cx="6.08107" cy="35.1351" r="0.675676" fill="#A6026A" />
      <circle cx="45.4392" cy="18.5811" r="0.675676" fill="#00BDB6" />
    </svg>
  )
}

export default GatsbyOssIcon
